<template>
  <div class="h-100 p-0 m-0">
    <div class="col-12 p-0 m-0">
      <div class="card padding-20">
        <div class="row p-0 m-0 mb-3 align-items-center justify-content-between">
          <div class="col-md-6 p-0">
            <h4 class="m-0 font-weight-bold">Օգտատերերի կառավարում</h4>
          </div>
          <div class="col-md-6 p-0 text-right">
            <button class="btn btn-primary" @click="$router.push('/user-management/create')">
              <i class="fa fa-plus mr-1"></i>  Ավելացնել օգտատեր
            </button>
          </div>
        </div>

        <!-- v-server-table -->
        <div class="table-responsive">
          <v-server-table
            ref="usersTable"
            :url="tableUrl"
            :columns="columns"
            :options="options"
          >
            <!-- Name -->
            <div slot="name" slot-scope="{ row }" class="d-flex align-items-center h-100">
              <span class="font-weight-medium">{{ row.name }}</span>
            </div>

            <!-- Phone -->
            <div slot="phone" slot-scope="{ row }" class="d-flex align-items-center h-100">
              {{ row.phone }}
            </div>

            <!-- Email -->
            <div slot="email" slot-scope="{ row }" class="d-flex align-items-center h-100">
              {{ row.email }}
            </div>

            <!-- Roles -->
            <div slot="roles" slot-scope="{ row }" class="d-flex align-items-center flex-wrap h-100 py-1">
              <span v-for="role in row.roles" :key="role" class="badge badge-primary mr-1 mb-1">
                {{ $t('roles.' + role) }}
              </span>
              <span v-if="!row.roles || row.roles.length === 0" class="text-muted">—</span>
            </div>

            <!-- Units -->
            <div slot="units" slot-scope="{ row }" class="d-flex align-items-center flex-wrap h-100 py-1">
              <span v-for="unit in row.units" :key="unit" class="badge badge-info mr-1 mb-1">
                {{ unit }}
              </span>
              <span v-if="!row.units || row.units.length === 0" class="text-muted">—</span>
            </div>

            <!-- Status -->
            <div slot="status" slot-scope="{ row }" class="d-flex align-items-center h-100">
              <span :class="row.status === 'ACTIVE' ? 'badge badge-success' : 'badge badge-danger'">
                {{ row.status === 'ACTIVE' ? '&#x0531;&#x056F;&#x057F;&#x056B;&#x057E;' : '&#x0531;&#x0576;&#x0561;&#x056F;&#x057F;&#x056B;&#x057E;' }}
              </span>
            </div>

            <!-- Created at -->
            <div slot="created_at" slot-scope="{ row }" class="d-flex align-items-center h-100 text-muted">
              {{ row.created_at || '—' }}
            </div>

            <!-- Actions -->
            <div slot="actions" slot-scope="{ row }" class="d-flex align-items-center h-100">
              <button
                class="btn btn-sm btn-outline-primary"
                @click="$router.push('/user-management/edit/' + row.id)"
                title=" Խմբագրել "
              >
                <i class="fa fa-edit mr-1"></i>  Խմբագրել
              </button>
            </div>
          </v-server-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserManagementList',
  methods: {},
  data() {
    return {
      tableUrl: `${process.env.VUE_APP_API_URL}user-management`,
      columns: ['id', 'name', 'phone', 'email', 'roles', 'units', 'status', 'created_at', 'actions'],
      options: {
        perPage: 10,
        perPageValues: [5, 10, 25, 50],
        sortable: ['id', 'email', 'phone', 'status', 'created_at'],
        columnsDropdown: false,
        filterByColumn: false,
        skin: 'table table-bordered table-hover',
        pagination: { chunk: 5 },
        headings: {
          id: '#',
          name: 'Անուն Ազգանուն',
          phone: 'Հեռախոսահամար',
          email: 'Էլ. փոստ',
          roles: 'Դերեր',
          units: 'Ստորաբաժանում',
          status: 'Կարգավիճակ',
          created_at: 'Ստեղծման ամսաթիվ',
          actions: 'Գործողություն',
        },
        texts: {
          count: 'Ցուցադրված է {from}֊ից {to}֊ը ընդհանուր {count}֊ից|{count} օգտատեր|',
          first: 'Առաջին',
          last: 'Վերջին',
          filter: '',
          filterPlaceholder: 'Որոնել...',
          limit: '',
          page: 'Էջ՝',
          noResults: 'Օգտատերեր չեն գտնվել',
          filterBy: 'Ֆիլտրել ըստ {column}֊ի',
          loading: 'Բեռնվում է...',
          defaultOption: 'Ընտրել {column}',
          columns: 'Սյուներ',
        },
        requestAdapter(data) {
          return {
            limit: data.limit ? data.limit : 10,
            page: data.page,
            query: data.query,
            orderBy: data.orderBy,
            ascending: data.ascending,
            byColumn: data.byColumn,
          }
        },
        responseAdapter({ data }) {
          return {
            data: data.data || [],
            count: data.count || 0,
          }
        },
        requestFunction(data) {
          return this.$client
            .get(this.url, { params: data })
            .catch(function (e) {
              this.dispatch('error', e)
            }.bind(this))
        },
      },
    }
  },
}
</script>

<style scoped>
.badge-success {
  background-color: #28a745;
  color: #fff;
}
.badge-danger {
  background-color: #dc3545;
  color: #fff;
}
.badge-primary {
  background-color: #006be6;
  color: #fff;
}
.badge-info {
  background-color: #17a2b8;
  color: #fff;
}
</style>
